import { Download as DownloadIcon } from "@mui/icons-material";
import { CircularProgress, IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import moment from "moment";
import { FC, useRef, useState } from "react";
// import { renderToString } from "react-dom/server";

import { ReactComponent as PDFIcon } from "../../assets/icons/file-pdf-box.svg";
import { ReactComponent as ExcelIcon } from "../../assets/icons/microsoft-excel.svg";
import { useDownloadJob } from "../../hooks/useDownloadReport";
import { useAppSelector } from "../../redux";
import { IEventLogRowDetails } from "../../types";
import { API_TIMESTAMP_FORMAT } from "../../utils/constants";

interface IDownloadReportProps {
	logs: IEventLogRowDetails[];
}

const logItemHTML = `<div class="logs-table-row">
  <div class="table-type-cell">
    <div class="log-type-indicator {log_type}"></div>
  </div>

  <div class="table-cell" style="max-width: 60pt">
    <p class="table-cell-text">{timestamp}</p>
  </div>

  <div class="table-icon-cell">{icon}</div>

  <div class="table-cell">
    <p class="table-cell-text" style="text-align: center">{number_plate}</p>
  </div>

  <div class="table-cell" style="max-width: 60pt">
    <p class="table-cell-text">{direction}</p>
  </div>

  <div class="table-cell" style="max-width: 60pt">
    <p class="table-cell-text">{camera_name}</p>
  </div>

  <div class="table-cell" style="max-width: 80pt">
    <p class="table-cell-text">{device_name}</p>
  </div>

  <div class="table-cell" style="max-width: 80pt">
    {plate_image}
  </div>

  <div class="table-cell" style="max-width: 60pt">
    {evidence_image}
  </div>
</div>`;

const logsPageHTML = `<div class="logs-page">
  <div class="page-content-wrapper">
    <div class="logs-page-wrapper">
      <div class="logs-table-wrapper">
        <div class="logs-table-header">
          <div class="table-type-cell"></div>

          <div class="table-cell" style="max-width: 60pt">
            <p class="table-cell-text">Time</p>
          </div>

          <div class="table-icon-cell">
            <p class="table-cell-text">Type</p>
          </div>

          <div class="table-cell">
            <p class="table-cell-text">Number Plate</p>
          </div>

          <div class="table-cell" style="max-width: 50pt">
            <p class="table-cell-text">Direction</p>
          </div>
          
          <div class="table-cell" style="max-width: 60pt">
            <p class="table-cell-text">Location</p>
          </div>

          <div class="table-cell" style="max-width: 80pt">
            <p class="table-cell-text">Device</p>
          </div>

          <div class="table-cell" style="max-width: 80pt">
            <p class="table-cell-text">Plate Image</p>
          </div>

          <div class="table-cell no-divider" style="max-width: 60pt">
            <p class="table-cell-text">Evidence Image</p>
          </div>
        </div>

        {content}
        <div id="logs-content">
        </div>
      </div>
    </div>
  </div>

  <div class="page-footer-wrapper">
    <svg viewBox="0 0 125 23" fill="#5B4DBE" width="125pt">
      <g clip-path="url(#gg-logo-clip-path)">
        <path
          d="M25.637 13.6466H24.2025V10.826H28.6682V16.9987C28.6682 17.5755 28.4457 18.0681 28.0006 18.4766C27.5616 18.8791 27.0383 19.0803 26.4309 19.0803H21.9742C21.3668 19.0803 20.8435 18.8791 20.4044 18.4766C19.9594 18.0681 19.7368 17.5755 19.7368 16.9987V5.91492C19.7368 5.33822 19.9594 4.84559 20.4044 4.43708C20.8435 4.0346 21.3668 3.83334 21.9742 3.83334H26.4309C27.0383 3.83334 27.5616 4.0346 28.0006 4.43708C28.4457 4.84559 28.6682 5.33822 28.6682 5.91492V8.97878H25.637V6.65385H22.7681V16.2598H25.637V13.6466ZM34.3247 13.4663H35.723L35.0193 7.29367L34.3247 13.4663ZM33.8014 16.1427L33.2151 19.0803H30.3011L33.1158 4.59928H36.9409L39.7466 19.0803H36.8237L36.2553 16.1427H33.8014ZM43.1748 7.27562H40.3601V4.59928H48.8494V7.27562H46.0435V19.0803H43.1748V7.27562ZM53.0985 16.404H57.8978V19.0803H50.2208V4.59928H57.8978V7.27562H53.0985V10.4927H57.0951V13.178H53.0985V16.404ZM66.5315 13.1149H59.7384V10.5647H66.5315V13.1149ZM74.6421 13.6466H73.2075V10.826H77.6734V16.9987C77.6734 17.5755 77.4509 18.0681 77.0058 18.4766C76.5665 18.8791 76.0434 19.0803 75.4357 19.0803H70.9793C70.3716 19.0803 69.8486 18.8791 69.4096 18.4766C68.9646 18.0681 68.742 17.5755 68.742 16.9987V5.91492C68.742 5.33822 68.9646 4.84559 69.4096 4.43708C69.8486 4.0346 70.3716 3.83334 70.9793 3.83334H75.4357C76.0434 3.83334 76.5665 4.0346 77.0058 4.43708C77.4509 4.84559 77.6734 5.33822 77.6734 5.91492V8.97878H74.6421V6.65385H71.7729V16.2598H74.6421V13.6466ZM83.0228 16.404H85.7475V4.59928H88.6342V17.1069C88.6342 17.6536 88.4207 18.1191 87.9937 18.5036C87.5791 18.8881 87.0827 19.0803 86.5054 19.0803H82.2744C81.6967 19.0803 81.1978 18.8881 80.7766 18.5036C80.3557 18.1191 80.1451 17.6536 80.1451 17.1069V4.59928H83.0228V16.404ZM94.5704 13.4663H95.9689L95.2651 7.29367L94.5704 13.4663ZM94.0473 16.1427L93.461 19.0803H90.5471L93.3617 4.59928H97.1866L99.9925 19.0803H97.0696L96.501 16.1427H94.0473ZM106.244 11.2406C106.521 11.2406 106.762 11.1474 106.966 10.9612C107.171 10.787 107.273 10.5678 107.273 10.3034V7.27562H104.548V11.2406H106.244ZM104.548 13.9169V19.0803H101.671V4.59928H108.031C108.608 4.59928 109.104 4.78855 109.519 5.167C109.946 5.5575 110.16 6.02606 110.16 6.57278V10.3034C110.16 11.2526 109.79 12.0095 109.05 12.5742C109.79 13.1389 110.16 13.9019 110.16 14.8631V19.0803H107.273V14.8631C107.273 14.5988 107.171 14.3735 106.966 14.1872C106.762 14.007 106.521 13.9169 106.244 13.9169H104.548ZM115.78 7.27562V16.404H117.143C118.051 16.404 118.505 16.0886 118.505 15.4578V7.27562H115.78ZM112.902 4.59928H119.262C119.84 4.59928 120.336 4.78855 120.751 5.167C121.178 5.5575 121.392 6.02606 121.392 6.57278V15.4578C121.392 16.5632 120.967 17.4553 120.12 18.1342C119.326 18.765 118.333 19.0803 117.143 19.0803H112.902V4.59928Z"
          fill="inherit"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.430194 15.6745C0.158379 15.4574 0 15.1285 0 14.7808V2.71103H5.12351C5.31882 2.71103 5.50519 2.79265 5.63747 2.93605L7.04215 4.45846V6.0645L4.82674 6.07291V5.20876H2.60842L2.62688 13.8705L4.82674 15.6512V12.1713L4.1391 12.1444C3.99449 12.1388 3.88016 12.0201 3.88016 11.8755V9.60954C3.88016 9.46096 4.00086 9.34043 4.1497 9.34043H7.04228V20.9567L0.430194 15.6745Z"
          fill="inherit"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.2275 15.6745C14.4994 15.4574 14.6577 15.1285 14.6577 14.7808V2.71103H9.53421C9.3389 2.71103 9.15254 2.79265 9.02025 2.93605L7.61557 4.45846V6.0645L9.83098 6.07291V5.20876H12.0493L12.0308 13.8705L9.83098 15.6512V12.1713L10.5186 12.1444C10.6632 12.1388 10.7776 12.0201 10.7776 11.8755V9.60954C10.7776 9.46096 10.6569 9.34043 10.508 9.34043H7.61545V20.9567L14.2275 15.6745Z"
          fill="inherit"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.7352 6.44974V8.90716H3.88895V7.2401L4.7352 6.44974Z"
          fill="inherit"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.88998 6.44974V8.90716H10.7363V7.2401L9.88998 6.44974Z"
          fill="inherit"
        />
        <path d="M5.93543 6.40665H5.08914V8.9504H5.93543V6.40665Z" fill="inherit" />
        <path d="M7.13558 6.40665H6.28934V8.9504H7.13558V6.40665Z" fill="inherit" />
        <path d="M8.33582 6.40665H7.48953V8.9504H8.33582V6.40665Z" fill="inherit" />
        <path d="M9.53596 6.40665H8.68967V8.9504H9.53596V6.40665Z" fill="inherit" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.52001 2.51074H0.00350952V2.09155H5.70341L7.28156 3.79372L8.90183 2.09155H14.6192V2.51074H9.082L7.27749 4.40638L5.52001 2.51074Z"
          fill="inherit"
        />
      </g>
      <defs>
        <clipPath id="gg-logo-clip-path">
          <rect width="100%" height="100%" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <div class="page-footer-line"></div>

    <div class="footer-page-number">
      <p>{page}</p>
    </div>
  </div>
</div>`;

const DownloadReport: FC<IDownloadReportProps> = (props) => {
	const { logs } = props;

	const filtersState = useAppSelector((state) => state.filters);

	const { eventLogsFilters: filters } = filtersState;

	const { isLoading: downloadExcelLoader, startDownload } = useDownloadJob();

	const downloadMenuButtonRef = useRef<HTMLButtonElement>(null);

	const [downloadMenuOpen, setDownloadMenuOpen] = useState<boolean>(false);
	const [downloadLoader, setDownloadLoader] = useState<boolean>(false);

	function handleOpenDownloadMenu() {
		setDownloadMenuOpen(true);
	}

	function handleCloseDownloadMenu() {
		setDownloadMenuOpen(false);
	}

	function handleDownloadExcel() {
		handleCloseDownloadMenu();

		startDownload({
			report_type: "logs",
			job_meta_data: {
				filters: {
					start_date: filters.timestamp__gte,
					end_date: moment(filters.timestamp__lte, API_TIMESTAMP_FORMAT.TIME_FILTER).isAfter(moment())
						? moment().format(API_TIMESTAMP_FORMAT.TIME_FILTER)
						: filters.timestamp__lte,
					auth: filters.auth,
					camera: filters.camera,
					device_ids: filters.device,
					is_blacklisted: filters.is_blacklisted,
					is_entry: filters.is_entry,
					is_unauthorized: filters.is_unauthorized,
					is_visitor: filters.is_visitor,
					number_plate: filters.number_plate,
					society_ids: filters.society
				}
			}
		});
	}

	async function getImage(url: string): Promise<string> {
		return new Promise((resolve) => {
			if (!url) {
				resolve("");
				return;
			}

			const img = new Image();

			img.onload = () => {
				const canvas = document.createElement("canvas");
				const canvasContext = canvas.getContext("2d");

				canvas.width = img.naturalWidth;
				canvas.height = img.naturalHeight;
				canvasContext?.drawImage(img, 0, 0);

				const base64 = canvas.toDataURL("image/jpeg");

				resolve(base64);
			};

			img.onerror = () => {
				resolve("");
			};

			img.crossOrigin = "anonymous";
			img.src = url;
		});
	}

	async function handleDownloadPDF() {
		const startTime = +new Date();

		handleCloseDownloadMenu();
		setDownloadLoader(true);

		const demoReportElement = document.createElement("div");
		demoReportElement.className = "print-only";

		let page = 1;

		let start = 0;
		let end = 20;

		if (end > logs.length) {
			end = logs.length;
		}

		let template = "";

		while (true) {
			let pageTemplate = logsPageHTML;

			let pageTemplateReplace = "";

			for (const item of logs.slice(start, end)) {
				// let icon = (
				// 	<SvgComponent
				// 		src={item.vehicle_type_icon}
				// 		width={20}
				// 		height={20}
				// 		fill="var(--color-primary-main)"
				// 	/>
				// );

				let icon = "";
				const iconImage = await getImage(item.vehicle_type_icon ?? "");
				if (iconImage) {
					icon = `<img src="${item.vehicle_type_icon}" alt="${item.vehicle_number}_plate" loading="eager" width="20px" height="20px" style="object-fit: contain;" />`;
				}

				let logType = "warning";

				if (item.type === "blacklisted") logType = "error";
				if (item.type === "authorized") logType = "success";
				if (item.type === "visitor") logType = "info";

				let plateImageComponent = "";
				const plateImage = await getImage(item.plate_image ?? "");
				if (plateImage) {
					plateImageComponent = `<img src="${plateImage}" alt="${item.vehicle_number}_plate" loading="eager" width="100%" height="100%" style="object-fit: contain;" />`;
				}

				let evidenceImageComponent = "";
				const evidenceImage = await getImage(item.frame_image ?? "");
				if (evidenceImage) {
					evidenceImageComponent = `<img src="${evidenceImage}" alt="${item.vehicle_number}_evidence" loading="eager" width="100%" height="100%" style="object-fit: contain;" />`;
				}

				pageTemplateReplace += logItemHTML
					.replace("{timestamp}", moment(item.timestamp).format("DD/MM/YYYY hh:mm A"))
					.replace("{number_plate}", item.vehicle_number)
					.replace("{camera_name}", item.camera_name)
					.replace("{device_name}", item.device_name)
					// .replace("{icon}", renderToString(icon))
					.replace("{icon}", icon)
					.replace("{log_type}", logType)
					.replace("{direction}", item.is_entry ? "Entry" : "Exit")
					.replace("{plate_image}", plateImageComponent)
					.replace("{evidence_image}", evidenceImageComponent);
			}

			pageTemplate = pageTemplate.replace("{content}", pageTemplateReplace);
			pageTemplate = pageTemplate.replace("{page}", String(page));

			template += pageTemplate;

			page += 1;

			if (end < logs.length) {
				start = end;
				end = end + 20;

				if (end > logs.length) end = logs.length;
			} else if (end === logs.length) {
				break;
			}
		}

		demoReportElement.innerHTML = template;

		document.body.appendChild(demoReportElement);

		requestAnimationFrame(() => {
			setTimeout(() => {
				console.log("time taken", (+new Date() - startTime) / 1000, "seconds");
				window.print();
				document.body.removeChild(demoReportElement);
			}, 100);

			setDownloadLoader(false);
		});
	}

	return (
		<>
			<IconButton
				color="primary"
				ref={downloadMenuButtonRef}
				aria-haspopup
				aria-expanded
				id="download-menu-trigger"
				aria-controls="download-menu"
				onClick={handleOpenDownloadMenu}
				disabled={downloadLoader || downloadExcelLoader}
			>
				{downloadLoader || downloadExcelLoader ? <CircularProgress size={20} /> : <DownloadIcon />}
			</IconButton>

			<Menu
				disableAutoFocusItem
				id="download-menu"
				anchorEl={downloadMenuButtonRef.current}
				open={downloadMenuOpen}
				onClose={handleCloseDownloadMenu}
				MenuListProps={{ "aria-labelledby": "download-menu-trigger" }}
			>
				<MenuItem onClick={handleDownloadExcel}>
					<ListItemIcon>
						<ExcelIcon width={24} height={24} fill="var(--color-primary-main)" />
					</ListItemIcon>
					Download Excel
				</MenuItem>

				<MenuItem onClick={handleDownloadPDF}>
					<ListItemIcon>
						<PDFIcon width={24} height={24} fill="var(--color-primary-main)" />
					</ListItemIcon>
					Download PDF Report
				</MenuItem>
			</Menu>
		</>
	);
};

export default DownloadReport;
